import { Injectable, signal } from '@angular/core';
import { IBreadCrumb } from '../components/breadcrumb/breadcrumb.interface';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private labelResolvers = signal<Record<string, () => string>>({});

  setLabel(url: string, resolveLabel: () => string): void {
    this.labelResolvers.update((resolvers) => ({ ...resolvers, [url]: resolveLabel }));
  }

  refreshLabels(): void {
    this.labelResolvers.update((resolvers) => ({ ...resolvers }));
  }

  clearLabel(url: string): void {
    this.labelResolvers.update((resolvers) => {
      const remaining = { ...resolvers };
      delete remaining[url];
      return remaining;
    });
  }

  applyLabels(breadcrumbs: IBreadCrumb[]): IBreadCrumb[] {
    const resolvers = this.labelResolvers();

    return breadcrumbs.map((crumb) => {
      const resolveLabel = crumb.url ? resolvers[crumb.url] : undefined;
      return resolveLabel ? { ...crumb, label: resolveLabel() } : crumb;
    });
  }
}
